module.exports = __webpack_public_path__ + "img/tallerAutomotriz.dba3131a.svg";